import { oneOfGroup } from '../../user/utils/group.js';
import { useAuthUser } from '@fabric-app/compat';
import { UserGroup } from '@fabric-app/types/user';

const defaultGetIsEnabledForUser = (user) => {
  if (!user) {
    return false;
  }
  if (oneOfGroup(user, [
    UserGroup.ADMIN
  ])) {
    return true;
  }
  if (user.email.endsWith("@fabric.so")) {
    return true;
  }
  return false;
};
const defaultOptions = {
  getIsEnabledForUser: defaultGetIsEnabledForUser
};
const useDevelopmentFlag = (options) => {
  const mergedOptions = {
    ...defaultOptions,
    ...options
  };
  const { getIsEnabledForUser } = mergedOptions;
  const user = useAuthUser();
  if (process.env.REACT_APP_ENV === "develop") {
    return true;
  }
  return Boolean(getIsEnabledForUser(user));
};

export { useDevelopmentFlag };
//# sourceMappingURL=useDevelopmentFlag.js.map
